<template>
    <li>
        <!-- SHARE MENU LINK -->
        <a href="" @click.prevent="openClearCartModal" id="new-cart-vue"><!-- Labels: No, Yes, Cancel-->
            <i class="csi-iconfont csi-cart"></i>
            {{ labels[1027] }}<!-- label: New/Clear Cart -->
        </a>

        <!-- MODAL WINDOW -->
        <modal v-if="isModalVisible" @close="closeClearCartModal" size="xs">
            <template v-slot:header>
                <span class="ui-dialog-title">Cart Not Saved</span><!-- todo: Label: -->
            </template>

            <template v-slot:body>
                <p v-html="labels[1041]"></p><!-- You have not saved your current cart.<br />Do you want to save it? -->
            </template>

            <template v-slot:footer>
                <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
                    <div class="ui-dialog-buttonset">
                        <button type="button" @click="closeClearCartModal(false)" class="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only" role="button">
                            <span class="ui-button-text">{{labels[1030]}}</span>
                        </button>
                        <button type="button" @click="closeClearCartModal(true)" class="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only" role="button">
                            <span class="ui-button-text">{{labels[1035]}}</span>
                        </button>
                        <button type="button" @click="saveCart()" class="btn-primary ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only" role="button">
                            <span class="ui-button-text">{{labels[1036]}}</span>
                        </button>
                    </div>
    			</div>
            </template>
        </modal>
    </li>
</template>

<script>
import useCart from "../composables/useCart"
import useCMS from "../../shared/composables/useCMS"
import Modal from '../../shared/components/Modal.vue';
import { ref } from '@vue/composition-api';

export default {
    name: 'CartClear',
    components: {
        Modal
    },
    setup () {
        const { cart, toggleSaveCart, loadNewCart } = useCart();
        const { labels } = useCMS();
        const { isModalVisible, closeClearCartModal, openClearCartModal, saveCart } = useCartClearModal(cart, toggleSaveCart, loadNewCart);

        return {
            isModalVisible,
            toggleSaveCart,
            openClearCartModal,
            closeClearCartModal,
            saveCart,
            loadNewCart,
            labels
        }
    }
}

function useCartClearModal (cart, toggleSaveCartModal, loadNewCart) {
    const isModalVisible = ref(false);

    const closeClearCartModal = (doLoadNewCart) => {
        if (doLoadNewCart) {
            loadNewCart();
        }
        isModalVisible.value = false;
    }

    const openClearCartModal = () => {
        if (!cart.value.info.saved) {
            isModalVisible.value = true;
        } else {
            loadNewCart();
        }
    }

    const saveCart = () => {
        closeClearCartModal(false);
        toggleSaveCartModal();
    }

    return {
        isModalVisible,
        closeClearCartModal,
        openClearCartModal,
        saveCart,
    }
}
</script>
